import { Banner } from "@alpacahq/ui/old";

import type { IRAOnboardingProps } from "..";

const COMMUNITY_PROPERTY_STATES = [
  "AZ",
  "CA",
  "ID",
  "LA",
  "NV",
  "NM",
  "TX",
  "WA",
  "WI",
];

const getIsCommunityPropertyBannerDisplayed = (
  tradeAccountDetails: IRAOnboardingProps["tradeAccountDetails"],
) =>
  tradeAccountDetails.marital_status === "MARRIED" &&
  COMMUNITY_PROPERTY_STATES.includes(tradeAccountDetails.state ?? "");

interface CommunityPropertyBannerProps {
  tradeAccountDetails: IRAOnboardingProps["tradeAccountDetails"];
}

export const CommunityPropertyBanner = ({
  tradeAccountDetails,
}: CommunityPropertyBannerProps) => {
  const isCommunityPropertyBannerDisplayed =
    getIsCommunityPropertyBannerDisplayed(tradeAccountDetails);

  if (!isCommunityPropertyBannerDisplayed) {
    return null;
  }

  return (
    <Banner
      variant="warning"
      title="Important Notice"
      message="If you've indicated that you're married and reside in a community property state (AZ, CA, ID, LA, NV, NM, TX, WA, or WI), you may be required to name your spouse as the sole beneficiary of your IRA account. If you name a beneficiary that is not your spouse, Alpaca will require your spouse's written consent. We'll reach out directly if your account meets these criteria and requires additional documentation."
    />
  );
};
